import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Card } from "../components/primitives";

export default function Watchlists() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/screening/lists").then(r => setD(r.data)); }, []);
  if (!d) return <div className="p-6 text-[13px] text-ink-muted">Loading…</div>;
  const all = [...d.sanctions.ofac, ...d.sanctions.un, ...d.sanctions.eu, ...d.sanctions.cbn, ...d.sanctions.efcc];
  return (
    <div>
      <PageHeader title="Watchlists" subtitle={`${all.length} entries across OFAC SDN, UN, EU, CBN, EFCC`} sections={["5.3"]} />
      <div className="p-6">
        <Card>
          <table className="dense w-full">
            <thead><tr><th>Reference</th><th>Name</th><th>List</th><th>Programmes</th><th>Updated</th></tr></thead>
            <tbody>
              {all.slice(0, 200).map(e => (
                <tr key={e.id}><td className="hash-mono text-[11px]">{e.id}</td><td className="text-[12px] font-medium">{e.name}</td><td className="text-[11px]">{e.list}</td><td className="text-[11px]">{(e.programmes||[]).join(", ")}</td><td className="text-[11px]">{e.updated}</td></tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    </div>
  );
}
